import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Home from './Home';
import Members from './Members';
import Event from './Event';
import Footer from './Footer';
import './App.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CookieBar from './CookieBar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Nav, Container } from 'react-bootstrap';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar bg="transparent" expand="lg">
          <Container>
            <div className="App-header-logo">
              <Navbar.Brand as={Link} to="/">
                <img
                  src={`${process.env.PUBLIC_URL}/images/logo_square.png`}
                  alt="logo associazione viviTirrenia"
                  height="30"
                />
              </Navbar.Brand>
            </div>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                <Nav.Link as={Link} to="/">Home</Nav.Link>
                <Nav.Link as={Link} to="/event">Eventi</Nav.Link>
                <Nav.Link as={Link} to="/members">Membri</Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        <div className="App-header">
          <div className="cover-image-container">
            <img src={`${process.env.PUBLIC_URL}/images/TirreniaPiazzaBelvedere.png`} className="cover-image" alt="foto Piazza Belvedere Tirrenia" />
            <div className="overlay"></div>
          </div>
        </div>

        <div className="App-content container">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/members" element={<Members />} />
            <Route path="/event" element={<Event />} />
          </Routes>
        </div>
        <Footer />
        <CookieBar />
      </div>
    </Router>
  );
}

export default App;
